import request from '../utils/request';

// 分页查询商家资质列表
export function listMerchantQualifications(params) {
  return request({
    url: '/merchant-qualification/list',
    method: 'post',
    data: {
      page: params.page || 1,
      pageSize: params.pageSize || 10,
      startTime: params.startTime,
      endTime: params.endTime,
      sortField: params.sortField || 'create_time',
      sortOrder: params.sortOrder || 'desc',
      ...params
    }
  });
}

// 根据ID获取商家资质详情
export function getMerchantQualificationById(id) {
  return request({
    url: `/merchant-qualification/${id}`,
    method: 'get'
  });
}

// 新增商家资质
export function addMerchantQualification(data) {
  return request({
    url: '/merchant-qualification/add',
    method: 'post',
    data
  });
}

// 更新商家资质
export function updateMerchantQualification(data) {
  return request({
    url: '/merchant-qualification/update',
    method: 'put',
    data
  });
}

// 删除商家资质
export function deleteMerchantQualificationById(id) {
  return request({
    url: `/merchant-qualification/${id}`,
    method: 'delete'
  });
}
